import type { Payment, Sale } from '@/offline/types'

/** Sum of 'in' payments recorded against a sale (partial receipts after the initial received). */
export function paymentsReceivedFor(saleId: string, payments: Payment[]): number {
  return payments
    .filter(
      (p) =>
        p.related_type === 'sale' &&
        p.related_id === saleId &&
        p.direction === 'in' &&
        !p.deleted_at,
    )
    .reduce((sum, p) => sum + p.amount_paisa, 0)
}

/**
 * Outstanding (udhaar) balance for a sale = sale amount - received at sale time - later partial
 * receipts. Derived, never stored, so it cannot desync. Floored at 0 (no negative receivable).
 */
export function saleOutstanding(sale: Sale, payments: Payment[]): number {
  return Math.max(0, sale.sale_amount_paisa - sale.received_paisa - paymentsReceivedFor(sale.id, payments))
}
